import { readableColor } from "polished";
import get from "lodash.get";
import textStyles from "../constants/textStyles";

/* eslint-disable sort-keys */
export default {
    Heading: {
        baseStyle: ({ theme: { colors }, background, bg }) => ({
            fontFamily: "heading",
            color: get(colors, background || bg) ? readableColor(get(colors, background || bg), colors.white, colors.black) : "current"
        }),
        sizes: {
            "3xl": {
                fontSize: "5xl",
                lineHeight: "base",
                fontWeight: "normal"
            },
            "2xl": {
                fontSize: "2xl",
                lineHeight: "shorter",
                fontWeight: "normal",
            },
            "xl": {
                fontSize: "xl",
                lineHeight: "base",
                fontWeight: "bold",
            },
            "lg": {
                fontSize: "xl",
                lineHeight: "shorter",
                fontWeight: "normal",
            },
            "md": {
                fontSize: "md",
                lineHeight: "shorter",
                fontWeight: "bold",
            },
            "sm": {
                fontSize: "md",
                lineHeight: "shorter",
                fontWeight: "normal",

            },
            "xs": {
                fontSize: "sm",
                lineHeight: "shorter",
                fontWeight: "normal",
            },
            "xlarge": {
                fontSize: "xl",
                lineHeight: "base",
                fontWeight: "bold"
            },
            "large": {
                fontSize: "xl",
                lineHeight: "shorter",
                fontWeight: "normal"
            },
            "medium": {
                fontSize: "md",
                lineHeight: "shorter",
                fontWeight: "bold"
            },
            "small": {
                fontSize: "md",
                lineHeight: "shorter",
                fontWeight: "normal"
            },
            "xsmall": {
                fontSize: "sm",
                lineHeight: "shorter",
                fontWeight: "normal"
            },
        },
        variants: {
            normal: {
                fontStyle: "normal"
            },
            cursive: {
                fontStyle: "italic"
            },
            authenticationAndAuthorisationHeading: {
                textAlign: "center",
                w: "full",
                fontSize: "3xl",
                mb: "4"
            },
            h1: {
                ...textStyles.h1,
            },
            h2: {
                ...textStyles.h2,
            },
            h3: {
                ...textStyles.h3,
            },
            h4: {
                ...textStyles.h4,
            },
            h5: {
                ...textStyles.h5,
            },
        },
        defaultProps: {
            variant: "h1",
        },
    }
};
